var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      class: ["parametric-card", { "is-booked": _vm.flat.isBooked }],
      attrs: { href: _vm.flat.link }
    },
    [
      _c("div", { staticClass: "parametric-card__content" }, [
        _c("div", { staticClass: "parametric-card__params" }, [
          _c(
            "h2",
            {
              staticClass: "parametric-card__title parametric-results__loader"
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.flat.title) +
                  "\n                "
              ),
              !_vm.isEstateFlat && _vm.flat.building && _vm.flat.section
                ? _c(
                    "span",
                    { staticClass: "parametric-results__annotation" },
                    [
                      _vm._v(
                        "\n                    Корпус " +
                          _vm._s(_vm.flat.building) +
                          ", секция " +
                          _vm._s(_vm.flat.section) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.flat.options
            ? _c(
                "ul",
                { staticClass: "tags tags_theme_not-order" },
                _vm._l(_vm.flat.options, function(option) {
                  return _c(
                    "li",
                    {
                      key: option.key,
                      class: [
                        "tags__item",
                        "tags__item_color_" + option.color,
                        "tags__item_theme_flat",
                        "tags__item_theme_narrow",
                        "parametric-results__loader"
                      ]
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(option.name) +
                          "\n                "
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            {
              class: [
                "parametric-card__params-list",
                _vm.isEstateFlat ? "" : "commerce"
              ]
            },
            [
              _c(
                "li",
                {
                  staticClass:
                    "parametric-card__params-list-item parametric-results__loader"
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.flat.area) + " м"),
                    _c("sup", [_vm._v("2")])
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.isEstateFlat
                ? _c(
                    "li",
                    {
                      staticClass:
                        "parametric-card__params-list-item parametric-results__loader"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.flat.floor) +
                          "/" +
                          _vm._s(_vm.flat.floorsTotal) +
                          " этаж\n                "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass:
                    "parametric-card__params-list-item parametric-results__loader"
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.flat.deadlineText) +
                      "\n                "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.flat.isBooked
            ? _c(
                "div",
                {
                  staticClass:
                    "parametric-card__state parametric-results__loader"
                },
                [_vm._v("Забронировано")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.flat.isBooked
            ? _c("div", { staticClass: "parametric-card__prices" }, [
                _c("div", { staticClass: "parametric-results__loader" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        Number(_vm.flat.price)
                          ? _vm.convertToDigit(_vm.flat.price) + " руб"
                          : _vm.flat.price
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _vm.flat.priceOld
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "parametric-card__price-old parametric-results__loader"
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              Number(_vm.flat.priceOld)
                                ? _vm.convertToDigit(_vm.flat.priceOld) + " руб"
                                : _vm.flat.priceOld
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "parametric-card__plan" }, [
          _c("div", { staticClass: "parametric-results__loader" }, [
            _c("img", { attrs: { src: _vm.flat.plan, alt: _vm.flat.title } })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }